const queueType = {
  BULL: 1,
  RABBITMQ: 2,
};

const queues = [
  {
    type: 1,
    name: 'Bull',
  },
  {
    type: 2,
    name: 'Rabbit MQ',
  },
];

const queueTypeMap = queues.reduce(
  (acc, queue) => Object.assign(acc, { [queue.type]: queue }), {});

module.exports = {
  queueType,
  queueTypeMap,
};
